export default __webpack_public_path__ + "static/media/CD__0000_0001.57cffede.png";